import { render, staticRenderFns } from "./AsanaStoresTable.vue?vue&type=template&id=5f5d7fc2&scoped=true&"
import script from "./AsanaStoresTable.vue?vue&type=script&lang=js&"
export * from "./AsanaStoresTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f5d7fc2",
  null
  
)

export default component.exports